import gql from 'graphql-tag';

export const createTemporallyCheckupReservationIndividual = gql`
  mutation createTemporallyCheckupReservationIndividual($input: ReserveCheckupAppointmentInput!) {
    reserveCheckupAppointmentIndividualTemporarily(input: $input) {
      id
    }
  }
`;
